module.exports = __webpack_public_path__ + "static/media/ringtone-2.f845b2d3.mp3";